"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KatalMetricsDriverSushi = void 0;
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _KatalMetricsDriver2 = _interopRequireDefault(require("@amzn/katal-metrics/lib/driver/KatalMetricsDriver"));
var _KatalMetricType = _interopRequireDefault(require("@amzn/katal-metrics/lib/metricObject/KatalMetricType"));
var _katalSushiClient = _interopRequireDefault(require("@amzn/katal-sushi-client"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var KAT_STANDALONE_NEXUS_PRODUCER_ID = 'katal';
var KAT_STANDALONE_DEFAULT_SOURCE_GROUPS = {
  test: 'com.amazon.eel.katal.metrics.core.nexus.gamma',
  prod: 'com.amazon.eel.katal.metrics.core.nexus'
};
var EU_EXPANSION_REALM_ENUM = /*#__PURE__*/function (EU_EXPANSION_REALM_ENUM) {
  EU_EXPANSION_REALM_ENUM["EU_SOUTH_2"] = "eu-south-2";
  EU_EXPANSION_REALM_ENUM["EU_CENTRAL_1"] = "eu-central-1";
  return EU_EXPANSION_REALM_ENUM;
}(EU_EXPANSION_REALM_ENUM || {});
;
// https://w.amazon.com/bin/view/Region_Flexibility/Tech_Guidance/Deep_Dives_and_Announcements/Deep_Dives/Realm_Recommendation/
var EU_EXPANSION_REALMS = [EU_EXPANSION_REALM_ENUM.EU_SOUTH_2, EU_EXPANSION_REALM_ENUM.EU_CENTRAL_1];
var DEFAULT_TYPE_TO_SCHEMA_MAP = new Map([[_KatalMetricType.default.String, 'katal.client.metrics.String.2'], [_KatalMetricType.default.Counter, 'katal.client.metrics.Counter.3'], [_KatalMetricType.default.Timer, 'katal.client.metrics.Timer.2']]);
var KatalMetricsDriverSushiBuilder = /*#__PURE__*/function () {
  function KatalMetricsDriverSushiBuilder() {
    (0, _classCallCheck2.default)(this, KatalMetricsDriverSushiBuilder);
    (0, _defineProperty2.default)(this, "context", {});
  }
  return (0, _createClass2.default)(KatalMetricsDriverSushiBuilder, [{
    key: "withSushiClient",
    value: function withSushiClient(sushiClient) {
      console.log('withSushi client...');
      this.context.sushiClient = sushiClient;
      return this;
    }
  }, {
    key: "withDomainRealm",
    value: function withDomainRealm(domain, realm) {
      this.context.domain = domain;
      this.context.realm = realm;
      return this;
    }
  }, {
    key: "withCustomProducer",
    value: function withCustomProducer(sushiProducerId) {
      this.context.sushiProducer = sushiProducerId;
      return this;
    }
  }, {
    key: "withCustomSourceGroup",
    value: function withCustomSourceGroup(sourceGroupId) {
      this.context.sourceGroupId = sourceGroupId;
      return this;
    }
  }, {
    key: "withErrorHandler",
    value: function withErrorHandler(errorHandler) {
      this.context.errorHandler = errorHandler;
      return this;
    }
  }, {
    key: "withSushiClientOptions",
    value: function withSushiClientOptions(sushiClientOptions) {
      this.context.sushiClientOptions = sushiClientOptions;
      return this;
    }
  }, {
    key: "withSushiClientTransportOverride",
    value: function withSushiClientTransportOverride(sushiClientTransportOverride) {
      this.context.sushiClientTransportOverride = sushiClientTransportOverride;
      return this;
    }
  }, {
    key: "withMetricTypeToNexusSchemaMap",
    value: function withMetricTypeToNexusSchemaMap(metricTypeToNexusSchemaMap) {
      this.context.metricTypeToNexusSchemaMap = metricTypeToNexusSchemaMap;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return new KatalMetricsDriverSushi(this.context);
    }
  }]);
}();
var KatalMetricsDriverSushi = exports.KatalMetricsDriverSushi = /*#__PURE__*/function (_KatalMetricsDriver) {
  function KatalMetricsDriverSushi(options) {
    var _this;
    (0, _classCallCheck2.default)(this, KatalMetricsDriverSushi);
    _this = _callSuper(this, KatalMetricsDriverSushi);
    (0, _defineProperty2.default)(_this, "sushi", void 0);
    (0, _defineProperty2.default)(_this, "producerId", void 0);
    (0, _defineProperty2.default)(_this, "sourceGroupId", void 0);
    (0, _defineProperty2.default)(_this, "realm", void 0);
    (0, _defineProperty2.default)(_this, "errorHandler", void 0);
    (0, _defineProperty2.default)(_this, "metricTypeToNexusSchemaMap", void 0);
    /**
     * Call the error-handler supplied by the user when this object was constructed; if that is unset or itself throws
     * an exception, calls the default error handler as a fallback, which will just log the error to the console.
     *
     * @param err Error object to handle
     */
    (0, _defineProperty2.default)(_this, "combinedErrorHandler", function (err) {
      if (_this.errorHandler) {
        try {
          _this.errorHandler(err);
          // Return to avoid falling through to default error handler
          return;
        } catch (nextErr) {
          console.error("Error handling error publishing metrics:");
          console.error(nextErr);
          // Fall through
        }
      }
      _this.defaultErrorHandler(err);
    });
    var domain = options.domain,
      realm = options.realm,
      errorHandler = options.errorHandler,
      sushiClient = options.sushiClient,
      _options$sushiProduce = options.sushiProducer,
      producerId = _options$sushiProduce === void 0 ? KAT_STANDALONE_NEXUS_PRODUCER_ID : _options$sushiProduce,
      sushiClientOptions = options.sushiClientOptions,
      sushiClientTransportOverride = options.sushiClientTransportOverride,
      metricTypeToNexusSchemaMap = options.metricTypeToNexusSchemaMap;

    // custom source group always overrides defaults
    var sourceGroupId = options.sourceGroupId || KAT_STANDALONE_DEFAULT_SOURCE_GROUPS[domain] || KAT_STANDALONE_DEFAULT_SOURCE_GROUPS['test'];
    _this.sushi = sushiClient || _this.buildSushiClient(domain, realm, sourceGroupId, sushiClientOptions, sushiClientTransportOverride);
    _this.errorHandler = errorHandler;
    _this.producerId = producerId;
    _this.sourceGroupId = sourceGroupId;
    _this.metricTypeToNexusSchemaMap = metricTypeToNexusSchemaMap || DEFAULT_TYPE_TO_SCHEMA_MAP;
    _this.realm = realm;
    return _this;
  }
  (0, _inherits2.default)(KatalMetricsDriverSushi, _KatalMetricsDriver);
  return (0, _createClass2.default)(KatalMetricsDriverSushi, [{
    key: "beforeUnload",
    value:
    /**
     * Register a callback to be called right before the page unloads. This
     * allows for any final metrics, such as page visit duration, to be sent
     * before the user navigates away from the page or closes the tab.
     * NOTE: This is an experimental API and may change in the future.
     * @param cb The callback to call.
     */
    function beforeUnload(cb) {
      this.sushi.onSushiUnload(cb);
    }

    /**
     * Default error handler if the user-supplied error handler fails or is unset.  Should never be called unless
     * user-provided error handler misbehaves.
     *
     * @param err Unhandled error object
     */
  }, {
    key: "defaultErrorHandler",
    value: function defaultErrorHandler(err) {
      console.error("Error publishing metrics:");
      console.error(err);
    }
  }, {
    key: "withErrorHandling",
    value:
    /**
     * Helper method to wrap a function in the error handler.
     *
     * @param doTheThing Function to run under the wrapper
     * @return Return value from called function
     */
    function withErrorHandling(doTheThing) {
      try {
        return doTheThing();
      } catch (err) {
        this.combinedErrorHandler(err);
      }
    }
  }, {
    key: "buildSushiClient",
    value: function buildSushiClient(domain, realm, sourceGroupId, sushiClientOptions, sushiClientTransportOverride) {
      if (!domain || !realm) {
        throw new Error('KatalMetricsDriverSushi requires a domain and realm to build a sushi client.');
      }
      return new _katalSushiClient.default(KatalMetricsDriverSushi.getRealmName(realm), sourceGroupId, this.combinedErrorHandler, sushiClientOptions, sushiClientTransportOverride);
    }
  }, {
    key: "publish",
    value:
    // TODO: errorHandler in this method is deprecated and is not referenced.
    // Tech debt: https://issues.amazon.com/issues/KAT-875
    function publish(metricObject, errorHandler, context) {
      var _this2 = this;
      // Support for new 2-argument form of publish, which does not pass the unused errorHandler object (KAT-875)
      var metricsContext = arguments.length < 3 ? arguments[1] : arguments[2];
      this.withErrorHandling(function () {
        // TODO: This logic is now moved into KatalMetricsPublisher, once everybody has that update we can remove this.
        // Tech debt: https://issues.amazon.com/issues/KAT-876
        if (_KatalMetricType.default.List === metricObject.type) {
          metricObject.metricList.forEach(function (metric) {
            _this2.publish(metric, metricsContext);
          });
          return;
        }
        var nexusSchema = _this2.metricTypeToNexusSchemaMap.get(metricObject.type);
        // If schema map does not contain Nexus schema for object type, throw error 
        if (nexusSchema === undefined) {
          throw new Error("Unknown type ".concat(metricObject.type, " when publishing metric object."));
        }
        var fields = _objectSpread(_objectSpread({}, metricsContext.context), {}, {
          metricKey: metricObject.name,
          value: metricObject.value
        }, EU_EXPANSION_REALMS.includes(_this2.realm) ? {
          realm: _this2.realm
        } : {});
        if (metricObject.isMonitor) {
          fields.isMonitor = true;
        }
        // Deleting cloudWatchDimensions field if exists as it applies only for KatalMonitoringAWSDriver.
        if (fields.cloudWatchDimensions) {
          delete fields.cloudWatchDimensions;
        }
        // Reset the event count back to 0, otherwise Sushi will stop publishing after 1K items (https://issues.amazon.com/issues/KAT-1534)
        _this2.sushi.reset();
        _this2.sushi.event(fields, _this2.producerId, nexusSchema, {
          "ssd": 1
        });
      });
    }
  }], [{
    key: "getRealmName",
    value: function getRealmName(realm) {
      switch (realm) {
        case 'NAAmazon':
        case 'USAmazon':
          return _katalSushiClient.default.REGIONS.NA;
        case EU_EXPANSION_REALM_ENUM.EU_SOUTH_2:
        case EU_EXPANSION_REALM_ENUM.EU_CENTRAL_1:
        case 'EUAmazon':
          return _katalSushiClient.default.REGIONS.EU;
        case 'FEAmazon':
        case 'JPAmazon':
          return _katalSushiClient.default.REGIONS.FE;
        case 'CNAmazon':
          return _katalSushiClient.default.REGIONS.CN;
        default:
          // Let the SushiClient decide if this is bogus or not.
          return realm;
      }
    }
  }]);
}(_KatalMetricsDriver2.default);
(0, _defineProperty2.default)(KatalMetricsDriverSushi, "Builder", KatalMetricsDriverSushiBuilder);